import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login/Login.vue")
  },
  {
    path: "/mensajes",
    name: "Mensajes",
    component: () => import("../views/Login/Mensajes.vue")
  },
  {
    path: "/plataformaNoHabilitada",
    name: "PlataformaNoHabilitada",
    component: () => import("../views/Login/PlataformaNoHabilitada.vue")
  },
  {
    path: "/advertenciaPlataforma",
    name: "AdvertenciaPlataforma",
    component: () => import("../views/Login/AdvertenciaPlataforma.vue")
  },
  {
    path: "/plataformaNoHabilitadaActualizarDatos",
    name: "PlataformaNoHabilitadaActualizarDatos",
    component: () => import("../views/Login/PlataformaNoHabilitadaActualizarDatos.vue")
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Login/Login.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/registro",
    name: "Registro",
    component: () => import("../views/Registro/Registro.vue")
  },
  {
    path: "/registroExitoso",
    name: "RegistroExitoso",
    component: () => import("../views/Registro/RegistroExitoso.vue")
  },
  {
    path: "/miCuenta",
    name: "MiCuenta",
    component: () => import("../views/MiCuenta/MiCuenta.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/recarga",
    name: "Recarga",
    component: () => import("../views/MiCuenta/Recarga/Recarga.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/recarga/codigoRecarga",
    name: "CodigoRecarga",
    component: () => import("../views/MiCuenta/Recarga/CodigoRecarga.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/recarga/datosTransferencia",
    name: "DatosTransferencia",
    component: () => import("../views/MiCuenta/Recarga/DatosTransferencia.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/recarga/importeMercadoPago",
    name: "ImporteMercadoPago",
    component: () => import("../views/MiCuenta/Recarga/ImporteMercadoPago.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/recarga/mercadoPago",
    name: "MercadoPago",
    component: () => import("../views/MiCuenta/Recarga/MercadoPago.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/retiro",
    name: "Retiro",
    component: () => import("../views/MiCuenta/Retiro.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/datosPersonales",
    name: "DatosPersonales",
    component: () => import("../views/MiCuenta/DatosPersonales/DatosPersonales.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/solicitudExitosa",
    name: "SolicitudExitosa",
    component: () => import("../views/MiCuenta/DatosPersonales/Confirmacion.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/miCuenta/cambiarContrasena/cambiarContrasena",
    name: "CambiarContrasena",
    component: () => import("../views/MiCuenta/CambiarContrasena/CambiarContrasena.vue")
  },
  {
    path: "/miCuenta/cambiarContrasena/resultadoCambiarContrasena",
    name: "ResultadoCambiarContrasena",
    component: () => import("../views/MiCuenta/CambiarContrasena/ResultadoCambiarContrasena.vue")
  },
  {
    path: "/olvideMiContrasena/olvideMiContrasena",
    name: "OlvideMiContrasena",
    component: () => import("../views/OlvideMiContrasena/OlvideMiContrasena.vue")
  },
  {
    path: "/olvideMiContrasena/ingresarCodigo",
    name: "IngresarCodigo",
    component: () => import("../views/OlvideMiContrasena/IngresarCodigo.vue")
  },
  {
    path: "/olvideMiContrasena/nuevaContrasena",
    name: "NuevaContrasena",
    component: () => import("../views/OlvideMiContrasena/NuevaContrasena.vue")
  },
  {
    path: "/olvideMiContrasena/resultado",
    name: "Resultado",
    component: () => import("../views/OlvideMiContrasena/ResultadoCambioContrasenaOlvidada.vue")
  },
  {
    path: "/menu",
    name: "Menu",
    component: () => import("../views/Menu.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/carreras",
    name: "Carreras",
    component: () => import("@/views/Apuesta/Carreras.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tiposApuestas",
    name: "TiposApuestas",
    component: () => import("@/views/Apuesta/TiposApuestas.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/competidores",
    name: "Competidores",
    component: () => import("@/views/Apuesta/Competidores.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/vales",
    name: "Vales",
    component: () => import("@/views/Apuesta/Vales.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/ticket",
    name: "Ticket",
    component: () => import("@/views/Apuesta/Ticket.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/transmision",
    name: "Transmision",
    component: () => import("../views/Transmision.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/resultados",
    name: "Resultados",
    component: () => import("../views/Resultados/Carreras.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/resultadosCarrera",
    name: "ResultadosCarrera",
    component: () => import("../views/Resultados/ResultadosCarrera.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/historial",
    name: "Historial",
    component: () => import("../views/Historial/Historial.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/mostrarApuesta",
    name: "MostrarApuesta",
    component: () => import("../views/Historial/MostrarApuesta.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/resultadoAnulacion",
    name: "ResultadoAnulacion",
    component: () => import("../views/Historial/ResultadoAnulacion.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/programa",
    name: "Programa",
    component: () => import("../views/Programa.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/ayuda",
    name: "Ayuda",
    component: () => import("../views/Ayuda.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/actualizacionExterna/cargar",
    name: "ActualizacionExternaCargar",
    component: () => import("../views/ActualizacionExterna/Cargar.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/actualizacionExterna/actualizar",
    name: "ActualizacionExternaActualizar",
    component: () => import("../views/ActualizacionExterna/Actualizar.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/actualizacionExterna/exito",
    name: "ActualizacionExternaExito",
    component: () => import("../views/ActualizacionExterna/Exito.vue"),
    meta: {
      requiresAuth: false
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (from.path === "/ticket" && to.path !== "/menu") {
    next({ path: from.path });
    return;
  }

  if (to.path === "/") {
    store.dispatch("limpiarCredenciales");
    next();
    return;
  }

  if (from.path === "/" && store.state.sesion.usuario.token) {
    next();
    return;
  }

  if (from.path === "/" && (to.path === "/registro" || to.path === "/olvideMiContrasena/olvideMiContrasena")) {
    next();
    return;
  }

  if (from.path === "/menu" && to.path === "/vales") {
    next({ path: from.path });
    return;
  }

  if (from.path === "/menu" && to.path === "/competidores") {
    next({ path: from.path });
    return;
  }

  if (from.path === "/menu" && to.path === "/tiposApuestas") {
    next({ path: from.path });
    return;
  }

  if (from.path === "/") {
    next({ path: from.path });
    return;
  }

  // if (from.path === "/") {
  //   if (store.state.sesion.usuario.token) {
  //     console.log("entrada valida");
  //     next();
  //   } else {
  //     if (to.path === "/registro" || to.path === "/olvideMiContrasena/olvideMiContrasena") {
  //       next();
  //     } else {
  //       next( { path: from.path });
  //     }
  //   }
  // return;
  // }

  // if (to.path === "/") {
  //   store.dispatch("limpiarCredenciales");
  // }

  next();
});

export default router;
